// extracted by mini-css-extract-plugin
export default {"wrap":"ep-z","logoContainer":"fp-z","brandImg":"gp-z","logoImg":"hp-z","logoButton":"ip-z"};